import React, { useState } from "react";
import logo from "../../assets/testingimages/logo.jpg";

function ThankYoupython() {
  const [isHover, setIsHover] = useState(false);

  const pageStyle = {
    margin: 0,
    padding: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    flexDirection: "column",
    textAlign: "center",
  };

  const logoStyle = {
    width: "120px",
  };

  const thankText = {
    fontWeight: "bold",
    color: "green",
  };

  const homeBtn = {
    backgroundColor: isHover ? "#38b6ff" : "#080c6a", // hover color
    color: isHover ? "black" : "white",
    padding: "10px 22px",
    borderRadius: "5px",
    textDecoration: "none",
    marginTop: "20px",
    display: "inline-block",
    fontSize: "16px",
    cursor: "pointer",
    transition: "0.3s ease", // smooth hover
    fontWeight: isHover ? 500 : 300,
  };

  return (
    <div style={pageStyle}>
      <a href="/python-course-in-chennai">
        <img src={logo} alt="FAZO Academy Logo" style={logoStyle} />
      </a>

      <h1 style={thankText}>Thanking you</h1>

      <p><strong>We'll be in contact soon!</strong></p>

      <a
        href="/python-course-in-chennai"
        style={homeBtn}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        Go to home page
      </a>
    </div>
  );
}

export default ThankYoupython;
